import styled from "styled-components";

export const CredentialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px;
  border-radius: 15px;
  border: 2px solid red;
  margin-bottom: 10px;
  background-color: #eeeeee;
  color: #000;
  width: 90%;
  font-size: 14px;

  @media (min-width: 768px) {
    font-size: 18px;
    width: 70%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  height: 100vh;
  background-color: #fff;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const ContainerLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 25%;

  @media (min-width: 768px) {
    height: 100%;
    width: 30%;
  }
`;

export const ImgLogo = styled.img`
  width: 190px;
  height: 105px;
`;

export const ContainerInfoProd = styled.div`
  display: flex;
  margin-top: 5px;
  justify-content: center;

  q {
    width: 10rem;
    font-size: 12px;
    margin-top: 5px;
  }

  @media (min-width: 768px) {
    flex-direction: column-reverse;

    q {
      margin-left: 25px;
    }
  }
  @media (min-width: 1024px) {
    q {
      margin-left: 40px;
    }
  }
`;

export const InfoProd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 6rem;

  p {
    font-size: 12px;
    width: 4rem;
  }

  img {
    width: 4rem;
    border-radius: 99999px;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    width: 15rem;
    margin: 10px 0 0 25px;

    p {
      margin-left: 10px;
    }
  }

  @media (min-width: 1024px) {
    margin: 20px 0 0 40px;
  }
`;

export const ContainerLogin = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  height: 75%;
  background-color: #121c2c;
  justify-content: space-between;
  padding: 10px 0;

  @media (min-width: 768px) {
    height: 100%;
    width: 70%;
  }
`;

export const CreateAccount = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 15px;
  font-size: 14px;
  height: 10%;

  a {
    color: #fff;
  }

  span:first-child {
    margin-right: 5px;
  }

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const Display = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 90%;
  width: 100%;
  justify-content: center;
`;

export const Subtitle = styled.div`
  display: flex;
  font-size: 14px;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const SelectRadio = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
  width: 90%;
  align-items: center;
  font-size: 14px;

  input[type="radio"] {
    cursor: pointer;
    margin-right: 10px;
    justify-content: center;
    appearance: none;
    background-color: #fff;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid #000;
  }

  input[type="radio"]:checked {
    background-color: #fea500;
  }

  label {
    margin-right: 20px;
  }

  @media (min-width: 768px) {
    margin-left: 0px;
    font-size: 18px;

    input[type="radio"] {
      margin-right: 10px;
    }
  }

  @media (min-width: 1024px) {
    input[type="radio"] {
      height: 16px;
      width: 16px;
    }
  }
`;

export const FormUser = styled.div`
  display: flex;
  font-size: 14px;
  margin: 15px 0;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const TitleInput = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin: 15px 5px 5px 5px;

  a {
    color: #fff;
  }

  @media (min-width: 768px) {
    margin-left: 0px;
    font-size: 18px;
  }
`;

export const Inputtype = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 70%;

  @media (min-width: 768px) {
    width: 100%;
    max-width: 40%;
  }
`;

export const ButtonEnter = styled.div`
  width: 40%;

  button {
    font-size: 13px;
    width: 80%;
    height: 32px;
    border: none;
    border-radius: 5px;
    background-color: #38529c;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
  }

  @media (min-width: 768px) {
    margin-left: 2px;

    button {
      font-size: 15px;
    }
  }
`;

//#endregion ContainerLogin
